import { useEffect, useRef, useState } from "react";

import "./index.css";

import { Justify, Search, SortDown, SortUp } from "react-bootstrap-icons";
import Button from "react-bootstrap/Button";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Modal from "react-bootstrap/Modal";
import Row from 'react-bootstrap/Row';
import Table from "react-bootstrap/Table";

import Copy from '../../../../assets/img/copy.svg';
import EctLogoSimples from '../../../../assets/img/favi-ect.png';
import { filtrar } from "../../../../util/Filtros";

interface Props {
  numObjetoConsultado: string | null;
  linhaSelecionada: any | null;
  listaObjetoCombinacoes: any | null;
  show: boolean;
  setShow: (show: boolean) => void;
  handleShowModalObjetoCombinacao: (e: any, objeto: string, isOrigemModal: boolean) => void;
}

const ConsultaObjetoPorCombinacao = ({ numObjetoConsultado, linhaSelecionada, listaObjetoCombinacoes, show,   setShow, handleShowModalObjetoCombinacao }: Props) => {

    const handleClose = () => setShow(false)

    const columns = [
      { label: "#", accessor: "#", sortable: false, className: "text-center primeira-coluna", classNameData: "text-center" },
      { label: "Objeto", accessor: "objeto", sortable: true, className: "text-center", classNameData: "text-center" },
      { label: "Evento", accessor: "evento", sortable: true, className: "text-center", classNameData: "text-center" },
      { label: "Data Expedição", accessor: "dataCriacao", sortable: true, className: "", classNameData: "" },
      { label: "Código SRO Origem", accessor: "codSroOrigem", sortable: true, className: "text-center", classNameData: "text-center" },
      { label: "Unidade Origem", accessor: "nomeUnidadeOrigem", sortable: true, className: "text-center", classNameData: "text-center" },
      { label: "SE", accessor: "siglaSe", sortable: true, className: "text-center", classNameData: "text-center" },
    ];

    const columnsFiltrar = [
      "objeto", "evento", "dataCriacao", "codSroOrigem", "nomeUnidadeOrigem", "siglaSe"
    ];

    const divTable = useRef<null | HTMLInputElement>(null);
    const [filtro, setFiltro] = useState<string>('');
    const [sortField, setSortField] = useState("");
    const [order, setOrder] = useState("asc");
    const [numObjetoConsultar, setNumObjetoConsultar] = useState<string>('');
    const [listaObjetosCombinacoesFiltrada, setListaObjetosCombinacoesFiltrada] = useState<any>(listaObjetoCombinacoes);

    useEffect(() => {
        setNumObjetoConsultar(()=> '');
      },[])

      useEffect(() => {
          setNumObjetoConsultar(()=> '');
          setListaObjetosCombinacoesFiltrada(()=> listaObjetoCombinacoes)
      },[listaObjetoCombinacoes])

    const setFiltroInput = (event: React.ChangeEvent<HTMLInputElement>) => {
      event.preventDefault();
      setFiltro(event.target.value)

      if (event.target.value && event.target.value !== '' && event.target.value.length > 0) {

        let res: any = filtrar(listaObjetoCombinacoes, columnsFiltrar, event.target.value);

        setListaObjetosCombinacoesFiltrada(() => res)
      } else {
        setListaObjetosCombinacoesFiltrada(() => listaObjetoCombinacoes)
      }

    }

    const handleSortingChange = (accessor: string) => {
      const sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
      setSortField(accessor);
      setOrder(sortOrder);
      handleSorting(accessor, sortOrder);
    }
    const handleSorting = (sortField: string | number, sortOrder: string) => {

      if (sortField) {
        const sorted = [...listaObjetosCombinacoesFiltrada].sort((a, b) => {
          if ((a as Record<string, any>)[sortField] === null) return 1;
          if ((b as Record<string, any>)[sortField] === null) return -1;
          if ((a as Record<string, any>)[sortField] === null && (b as Record<string, any>)[sortField] === null) return 0;
          return (
            (a as Record<string, any>)[sortField].toString().localeCompare((b as Record<string, any>)[sortField].toString(), "pt-BR", {
              numeric: true,
            }) * (sortOrder === "asc" ? 1 : -1)
          );
        });

        setListaObjetosCombinacoesFiltrada(sorted);
      }
    };

    const returnCustomizadaTdObjeto = (accessor: string, data: any) => {
        return <td key={accessor} id={accessor} className='text-center'><a onClick={(e) => e.stopPropagation()} title={`Clique para rastrear o objeto ${data.objeto}`} href={`${process.env.REACT_APP_URL_PAGE_RASTREAMENTO}?objetos=${data.objeto}`} target="_blank" rel="noopener noreferrer"><strong>{data.objeto}</strong></a></td>;
    }

    const consultarObjetoTrocandoTresDigitosNumericos = (e: any, objeto: string) => {
        handleShowModalObjetoCombinacao(e,objeto,true);
    }

    return (
      <>
        <Modal className="mt-4" id="modal-objeto-combinacoes"
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <img src={EctLogoSimples}
                alt="Logo ECT"
                className="rounded me-2"
              />
              <strong className="me-auto">Sroconferencia - Consulta de objeto por combinações</strong>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">

            {<>
              <Form>
                <Form.Group as={Row} controlId="formModalListaObjetosCombinacoes" className="ms-0 me-0 mb-3 w-100 fs-5">
                    <Col className="fw-bold ps-1 pe-0 text-start">Objeto:
                    <Button variant="primary" className="ms-2 me-2" title="Clique para copiar o número do objeto." onClick={() => {navigator.clipboard.writeText(linhaSelecionada.objeto)}}><img className="margin-copy" src={Copy} alt="Clique para copiar o número do objeto."/>{linhaSelecionada && linhaSelecionada.objeto ? linhaSelecionada.objeto : ''}</Button>
                    Data Expedicão: <span className="badge bg-primary">{linhaSelecionada && linhaSelecionada.dataExpedicao ? linhaSelecionada.dataExpedicao : ''}</span> Origem: <span className="badge bg-primary">{linhaSelecionada && linhaSelecionada.uniOrigem ? `${linhaSelecionada.uniOrigem} - ${linhaSelecionada.seOrigem}`: ''}</span></Col>
                </Form.Group>

                <Form.Group as={Row} controlId="formModalListaObjetosCombinacoes" className="mb-3 w-100">
                  <Col sm={12} lg={3} xl={2} className="ms-1">
                    <Form.Control
                      type="search"
                      placeholder="Filtrar"
                      title="Digite algo para filtrar."
                      //disabled={!filtro && (!listaLoecObjetosSelecionada || listaLoecObjetosSelecionada.length === 0)}
                      value={filtro}
                      onChange={setFiltroInput}
                    />
                  </Col>
                  <Col sm={12} lg={6} xl={3} className="pe-0">
                    <Row className="align-items-center h-100 w-100 border rounded">
                        <Col sm={12} className="fw-bold">Consultado: <span className="badge bg-warning text-black fs-5">{numObjetoConsultado}</span></Col>
                    </Row>
                  </Col>
                  <Col sm={12} lg={3} xl={3} className="ps-0">
                    <InputGroup>
                            <Form.Control
                                placeholder="Objeto"
                                title="Informe um identificador de Unitizador ou Objeto para consultar."
                                aria-describedby="basic-addon2"
                                value={numObjetoConsultar}
                                onChange={(e) => setNumObjetoConsultar(() => e.target.value)}
                            />
                            <Button variant="primary" className="ps-1 py-0" id="button-addon2" disabled={!numObjetoConsultar || numObjetoConsultar.length !== 13}
                                title="Obrigatório substituir três dígitos númericos, em sequência, por ???. Exemplos: XX3???24975XX, XX134???539XX, XX975324???XX, XX???324975XX"
                                onClick={(e) => { consultarObjetoTrocandoTresDigitosNumericos(e, numObjetoConsultar) }}>
                                <Search className="icon-search" />
                                Trocar Números
                            </Button>
                        </InputGroup>
                  </Col>

                </Form.Group>

              </Form>
              <div ref={divTable} className="mb-0">
                <Table id="tabela-lista-combinacoes" responsive striped className="scroll mb-0">
                  <thead>
                    <tr>
                      {columns.map(({ label, accessor, sortable, className }) => {

                        const cl = sortable ? sortField === accessor && order === "asc"
                          ? <SortUp className="icon-table-sortable" />
                          : sortField === accessor && order === "desc"
                            ? <SortDown className="icon-table-sortable" />
                            : <Justify className="icon-table-sortable" />
                          : "";

                        return (
                          <th
                            key={accessor}
                            className={`${sortable ? `${className} cursor-pointer` : `${className}`}`}
                            onClick={sortable ? () => handleSortingChange(accessor) : undefined}
                          >
                            {cl}
                            {label}
                          </th>
                        );
                      })}
                    </tr>
                  </thead>

                  {listaObjetosCombinacoesFiltrada && listaObjetosCombinacoesFiltrada.length > 0 ?
                  (<tbody>
              {listaObjetosCombinacoesFiltrada.map((data: any, index: number) => {

                //let naoPendencia = inserirIcon(data);
                return (

                  <tr id={String(index)} key={index ? index : 0} className={data.dataCriacao.replaceAll('/', '').replaceAll('-', '').replaceAll(' ', '') !== 'linhaClicada' ? 'cursor-pointer' : 'cursor-pointer row-selecionada'}>
                    {columns.map(({ accessor, classNameData }) => {

                      const tData = (data as Record<string, any>)[accessor] || (data as Record<string, any>)[accessor] >= 0 ? (data as Record<string, any>)[accessor] : accessor === "#" ? index : "link";

                      return accessor === 'objeto' ? returnCustomizadaTdObjeto(accessor, data) : tData !== "link" ? <td id={accessor} key={accessor} className={!classNameData || classNameData === "" ? "" : classNameData}>{tData}</td>
                        :
                        <td id={accessor} key={accessor} className={!classNameData || classNameData === "" ? "" : classNameData}>

                        </td>
                    })}
                  </tr>
                );
              })}
            </tbody>)

          :

            (<tbody><tr><td colSpan={columns.length} className="text-center"><strong className="text-center">{`Não encontrou dados na consulta do objeto ${numObjetoConsultado}.`}</strong></td></tr></tbody>) 

            }
              </Table>
              </div>
            </>

            }

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {'Fechar'}
            </Button>
          </Modal.Footer>
        </Modal>

      </>
    )
  }

export default ConsultaObjetoPorCombinacao